var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('ChiCard',[(!_vm.loading)?_c('UserEditForm',{on:{"form-submitted":_vm.submitData}}):_c('PageLoading')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }